import { type FloorSpaceModel, type RoomSpaceModel, type Space, SpaceType } from '../models/spaces';

export const isFloor = (space: Space): space is FloorSpaceModel => space.type === SpaceType.floor;
export const isRoom = (space: Space): space is RoomSpaceModel => space.type === SpaceType.room;
